var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMuteActiveRedline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 9 14",
    style: {
      enableBackground: "new 0 0 9 14"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#0090C5;}\r\n\t.st1{fill:#FF0000;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.6,0.8C3.1,0.3,3.8,0,4.5,0s1.4,0.3,1.9,0.8s0.8,1.2,0.8,2v4.6c0,0.4-0.1,0.7-0.2,1.1c0,0,0,0.1-0.1,0.1 L1.8,3.4V2.8C1.8,2,2.1,1.3,2.6,0.8z M1.8,5.1v2.3c0,0.4,0.1,0.7,0.2,1.1c0.1,0.3,0.3,0.6,0.6,0.9C2.8,9.6,3.1,9.8,3.5,10 c0.3,0.1,0.7,0.2,1,0.2s0.7-0.1,1-0.2C5.8,9.9,6,9.7,6.2,9.6L1.8,5.1z M6.6,10c-0.6,0.5-1.3,0.7-2.1,0.7c-0.9,0-1.8-0.4-2.5-1.1 C1.4,8.9,1,8,1,7V5.6c0-0.1-0.1-0.3-0.1-0.4C0.8,5.1,0.6,5.1,0.5,5.1c-0.1,0-0.3,0.1-0.4,0.2C0.1,5.3,0,5.5,0,5.6V7 c0,1.1,0.4,2.3,1.1,3.1C1.9,11,2.9,11.5,4,11.7v0.9H2.5c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0.1-0.2,0.1c0,0-0.1,0.1-0.1,0.2 C2,12.9,2,13,2,13c0,0.1,0.1,0.3,0.1,0.4c0.1,0.1,0.2,0.2,0.4,0.2h3.9c0.1,0,0.3-0.1,0.4-0.2C6.9,13.3,7,13.2,7,13 c0-0.1,0-0.1,0-0.2c0-0.1-0.1-0.1-0.1-0.2c0,0-0.1-0.1-0.2-0.1c-0.1,0-0.1,0-0.2,0H5v-0.9c0.8-0.1,1.6-0.4,2.3-1L6.6,10z M8.1,9.8 C8.7,9,9,8,9,7V5.6c0-0.1-0.1-0.3-0.1-0.4C8.8,5.1,8.6,5.1,8.5,5.1c-0.1,0-0.3,0.1-0.3,0.2C8.1,5.3,8,5.5,8,5.6V7 c0,0.7-0.2,1.4-0.6,2L8.1,9.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.5,10.9L0.6,4c-0.2-0.2-0.2-0.6,0-0.9l0,0c0.2-0.2,0.6-0.2,0.9,0L8.4,10c0.2,0.2,0.2,0.6,0,0.9l0,0 C8.1,11.1,7.7,11.1,7.5,10.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMuteActiveRedline);
export default __webpack_public_path__ + "static/media/icon-mute-active-redline.76857c44b603d84b1df05f90012adc11.svg";
export { ForwardRef as ReactComponent };